
export abstract class DateHelper {

	static getNextDateByInterval(start: number, duration: number, interval: number): number {
		start = this.checkForTimestamp(start);
		let today: number = Math.round(Date.now()) / 1000;
		interval = (interval * 86400);
		let end: number = this.getEndDate(start, duration);
		let date: number = start + interval;
		if (date < end) {
			while (date < today) {
				date = date + interval;
			}
		} else {
			date = 0;
		}
		return date;
	}

	static getRemainingDays(start: number, duration: number): number {
		start = this.checkForTimestamp(start);
		let today: number = Math.round(Date.now()) / 1000;
		let end = this.getEndDate(start, duration);
		let day = end - (start > today ? start : today);
		return Math.round(day / 86400) + (start < today ? +1 : 0);
	}

	static getEndDate(start: number, duration: number): number {
		return this.checkForTimestamp(start) + duration * 86400
	}

	static checkForTimestamp(timestamp: number) {
		return (timestamp.toString().length == 13 ? timestamp / 1000 : timestamp)
	}

}
